import { render, staticRenderFns } from "./view-bulk-message-send-summary.vue?vue&type=template&id=7dbd8b02&scoped=true&"
import script from "./view-bulk-message-send-summary.vue?vue&type=script&lang=js&"
export * from "./view-bulk-message-send-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbd8b02",
  null
  
)

export default component.exports